import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { AppState } from '~src/bootstrap/redux/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '~src/commonInfra/utils/ConnectUtils';
import { deselectAll, selectAll } from '~src/spacesPlatform/actions/ContentExplorerSelectionActions';
import { selectSortOrder } from '~src/spacesPlatform/actions/SelectSortOrderAction';
import * as ContentFilterSelectors from '~src/spacesPlatform/selectors/ContentFilterSelectors';
import { selectContentExplorerToolbarState, selectContentFromAppState, selectSelectedContentItems } from '~src/spacesPlatform/selectors/ContentSelectors';
import * as DisplaySettingsSelectors from '~src/spacesPlatform/selectors/DisplaySettingsSelectors';
import * as SpaceInfoSelectors from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { ExplorerToolbar, ExplorerToolbarDispatchProps, ExplorerToolbarStateProps } from './ExplorerToolbar';

const mapStateToProps: MapStateToProps<ExplorerToolbarStateProps> = (state: AppState) => ({
    ...selectContentExplorerToolbarState(state),
    selectedItems: selectSelectedContentItems(state),
    isSelectionBusy: state.contentExplorer.selection.isBusy,
    contentFilter: ContentFilterSelectors.selectCurrentlyApplicableContentTypes(state),
    filterPanelShown: DisplaySettingsSelectors.selectDisplaySettings(state).showFilterPanel,
    currentViewMode: DisplaySettingsSelectors.selectDisplaySettings(state).explorerDisplayMode,
    itemCount: selectContentFromAppState(state).length,
    spaceInfo: SpaceInfoSelectors.selectSpaceInfo(state),
});

const mapDispatchToProps: MapDispatchToProps<ExplorerToolbarDispatchProps> = (dispatch) => bindActionCreators({
    selectAll,
    clearAllSelections: deselectAll,
    contentSortSelected: selectSortOrder,
}, dispatch);

export const ConnectedExplorerToolbar = connect(mapStateToProps, mapDispatchToProps)(ExplorerToolbar);